/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { isValueEmpty, isJsonString } from '@awp/helpers/utilsReact';
import { setPlacement, getSelectedPlacement, getSensorTypes, getjsonObject } from '@stores/sensorEquipmentPacketSlice';

const txtFontSize = {
  fontSize: '85%',
};

export const MetaFields = ({ props, objName, readOnly, index }) => {
  const dispatch = useDispatch();
  const selectedPlacement = useSelector(getSelectedPlacement);
  const sensorTypeList = useSelector(getSensorTypes);
  const jsonObj = getjsonObject(selectedPlacement, sensorTypeList);
  const objProperties =
    jsonObj && jsonObj.properties && Object.keys(jsonObj.properties).length > 0 ? jsonObj.properties[objName] : null;

  const updateSelectField = (e) => {
    let _selectedPlacement = { ...selectedPlacement };
    let json = { ...jsonObj };
    const st = sensorTypeList.find((opt) => opt.value == _selectedPlacement.SensorTypeId);
    let stJsonObj =
      st && !isValueEmpty(st.PlacementAttributeSchema) && isJsonString(st.PlacementAttributeSchema)
        ? JSON.parse(st.PlacementAttributeSchema)
        : null;
    let currentField = json.properties[objName];
    if (isValueEmpty(currentField)) {
      if (!stJsonObj || !stJsonObj.properties || stJsonObj.properties.length === 0) {
        _selectedPlacement.StructuredAttributes = '';
        dispatch(setPlacement(_selectedPlacement));
        return;
      }
    }
    if (isValueEmpty(stJsonObj.properties[objName])) {
      json.properties[objName] = null;
    } else {
      currentField = stJsonObj.properties[objName];
      currentField.value = e ? e.value : null;
      json.properties[objName] = currentField;
    }

    _selectedPlacement.StructuredAttributes = JSON.stringify(json);
    dispatch(setPlacement(_selectedPlacement));
  };
  const updateInputField = (e) => {
    e.preventDefault();
    let _selectedPlacement = { ...selectedPlacement };
    let json = { ...jsonObj };
    const st = sensorTypeList.find((opt) => opt.value == _selectedPlacement.SensorTypeId);
    let stJsonObj =
      st && !isValueEmpty(st.PlacementAttributeSchema) && isJsonString(st.PlacementAttributeSchema)
        ? JSON.parse(st.PlacementAttributeSchema)
        : null;
    let currentField = json.properties[objName];
    if (isValueEmpty(currentField)) {
      if (!stJsonObj || !stJsonObj.properties || stJsonObj.properties.length === 0) {
        _selectedPlacement.StructuredAttributes = '';
        dispatch(setPlacement(_selectedPlacement));
        return;
      }
    }
    if (isValueEmpty(stJsonObj.properties[objName])) {
      json.properties[objName] = null;
    } else {
      currentField = stJsonObj.properties[objName];
      currentField.value = e && e.target ? e.target.value : null;
      json.properties[objName] = currentField;
    }

    _selectedPlacement.StructuredAttributes = JSON.stringify(json);

    dispatch(setPlacement(_selectedPlacement));
  };
  const sectionItemsWithSelect = (item, i) => {
    const options = [...item.enum].map((value) => {
      return {
        label: value,
        value: value,
      };
    });

    return (
      item && (
        <Form.Group>
          <Form.Label>
            <b>{item.label}</b>
          </Form.Label>
          <br />
          <div key={`${index}_div_${i}`} style={txtFontSize}>
            <Select
              id={`${index}_div_select_${i}`}
              options={options}
              isClearable={true}
              value={{
                value: isValueEmpty(objProperties.value) ? '' : objProperties.value,
                label: isValueEmpty(objProperties.value) ? '' : objProperties.value,
              }}
              placeholder={'Select ...'}
              onChange={updateSelectField}
            />
          </div>
        </Form.Group>
      )
    );
  };

  const sectionItemsWithInput = (item, i) => {
    return (
      item && (
        <Form.Group>
          <Form.Label>
            <b>{item.label}</b>
          </Form.Label>
          <br />
          <Form.Control
            onChange={updateInputField}
            id={`${index}_input_${i}`}
            type="text"
            value={isValueEmpty(objProperties.value) ? '' : objProperties.value}
          />
          {/* {!isValueEmpty(getError(item.label)) &&
				<Form.Control.Feedback type="invalid"
						className="d-block">{getError(item.label)}
				</Form.Control.Feedback>} */}
        </Form.Group>
      )
    );
  };

  return objProperties && !isValueEmpty(objProperties.enum) && objProperties.enum.length > 0
    ? sectionItemsWithSelect(objProperties, index)
    : sectionItemsWithInput(objProperties, index);
};
